<!-- CopyRight (C) 2017-2022 Alibaba Group Holding Limited. -->
<!-- Created by Tw93 on 17/07/28. -->

<template>
  <wxc-cell :has-top-border="hasTopBorder"
            :has-bottom-border="hasBottomBorder"
            :has-vertical-indent="hasVerticalIndent"
            :cell-style="cellStyle"
            @wxcCellClicked="wxcCellClicked"
            :accessible="true"
            :value-on-right="radioButtonOnRight"
            :aria-label="`${title},状态为${checked?'已选中':'未选中'},${disabled?'不可更改':''}`">
    <weex-text >:style="{color:color, marginLeft:textMarginLeft}"
          class="title-text"
          slot="title">{{title}}</weex-text>
    <weex-image >:src="radioIcon"
           v-if="radioIcon"
           slot="value"
           class="radio"></weex-image>
  </wxc-cell>
</template>

<style scoped>
  .radio {
    width: 36px;
    height: 36px;
  }

  .title-text {
    font-size: 30px;
    line-height: 40px;
  }
</style>

<script>
  import WxcCell from '../wxc-cell';
  import { CHECKED, DISABLED } from './type.js'

  export default {
    components: { WxcCell },
    props: {
      hasTopBorder: {
        type: Boolean,
        default: false
      },
      hasBottomBorder: {
        type: Boolean,
        default: true
      },
      hasVerticalIndent: {
        type: Boolean,
        default: true
      },
      radioItemStyle: {
        type: Object,
        default: null
      },
      title: {
        type: String,
        require: true
      },
      value: {
        type: [String, Number, Object],
        require: true
      },
      disabled: {
        type: Boolean,
        default: false
      },
      checked: {
        type: Boolean,
        default: false
      },
      config: {
        type: Object,
        default: () => ({})
      },
      radioButtonOnRight: {
        type: Boolean,
        default: true
      }
    },
    data: () => ({
      icon: [CHECKED, DISABLED]
    }),
    computed: {
      radioIcon () {
        const { icon, disabled, checked, config } = this;
        const mergeIcon = icon;
        config.checkedIcon && (mergeIcon[0] = config.checkedIcon);
        config.disabledIcon && (mergeIcon[1] = config.disabledIcon);
        config.unCheckedIcon && (mergeIcon[2] = config.unCheckedIcon);
        return checked ? mergeIcon[disabled ? 1 : 0] : mergeIcon[disabled ? 1 : 2];
      },
      backgroundColor () {
        const { disabled } = this;
        return disabled ? '#F2F3F4' : '#FFFFFF';
      },
      cellStyle() {
        if (this.radioItemStyle) {
          return this.radioItemStyle
        } else {
          return { 'backgroundColor': this.backgroundColor }
        }
      },
      color () {
        const { disabled, checked, config } = this;
        let checkedColor = '#EE9900';
        config.checkedColor && (checkedColor = config.checkedColor);
        return checked && !disabled ? checkedColor : '#3D3D3D';
      },
      textMarginLeft() {
        return this.radioButtonOnRight ? '0px' : '18px';
      }
    },
    methods: {
      wxcCellClicked () {
        const { disabled, value } = this;
        if (!disabled) {
          this.$emit('wxcRadioItemChecked', { value, disabled })
        }
      }
    }
  }
</script>
